import { fmtMonthDay, fmtDate } from '../../utils/formatters';
import { eventStatusChip } from '../../store/useEventsStore';

export default function EventMiniRow({ event, onClick }) {
  const md = fmtMonthDay(event.date);
  const chip = eventStatusChip(event, fmtDate);
  return (
    <div className="ev-row-mini" onClick={onClick}>
      <div className="ev-date-badge">
        <div className="mo">{md.mo}</div>
        <div className="dy">{md.dy}</div>
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div className="ev-title">{event.title}</div>
      </div>
      <span className={`ev-status ${chip.cls}`}>{chip.text}</span>
    </div>
  );
}
